module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-6297a609d7115823ba66824b9de6c773.svg";